import { styled } from '@mui/material/styles'
import { Box, type BoxProps, useTheme } from '@mui/material'
import type { SvgIconComponent } from '@mui/icons-material'
import type { ThemeVariant } from '@/types/status.types'

export const Container = styled(Box)<{ noPadding: boolean }>(({ theme, noPadding }) => ({
  lineHeight: 1,
  borderRadius: theme.shape.borderRadius,
  padding: noPadding ? 0 : '0.5em'
}))

interface ContainedIconProps extends BoxProps {
  icon: SvgIconComponent
  variant?: ThemeVariant
  size?: BoxProps['width'] & BoxProps['height']
  iconSize?: BoxProps['fontSize']
}

export function ContainedIcon({
  icon: Icon,
  variant,
  size = '40px',
  iconSize,
  ...rest
}: ContainedIconProps) {
  const theme = useTheme()

  const normalizedVariant = variant === 'default' ? 'primary' : variant
  const paletteVariant = normalizedVariant ? theme.palette[normalizedVariant] : undefined

  const backgroundColor = paletteVariant
    ? paletteVariant.light
    : theme.palette.background.paper

  const contrastColor = paletteVariant ? paletteVariant.dark : theme.palette.text.primary

  return (
    <Container
      noPadding={iconSize != undefined}
      {...rest}
      sx={{
        ...rest.sx,
        background: backgroundColor,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      width={size}
      height={size}
    >
      {iconSize != undefined ? (
        <Icon
          htmlColor={contrastColor}
          sx={{
            fontSize: iconSize,
            aspectRatio: 1
          }}
        />
      ) : (
        <Icon
          htmlColor={contrastColor}
          sx={{
            aspectRatio: 1
          }}
        />
      )}
    </Container>
  )
}
